import { Controller } from "@hotwired/stimulus"

// Handles onboarding form flow and transitions
export default class extends Controller {
  static targets = ["sections", "step", "nameInput", "emails"]

  connect() {
    this.currentStep = 1
    this.showCurrentStep()
  }

  showCurrentStep() {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle("hidden", index + 1 !== this.currentStep)
    })
  }

  validateName(event) {
    const name = event.target.value
    if (name.length >= 3) {
      this.currentStep = 2
      this.showCurrentStep()
    }
  }

  templateSelected() {
    this.currentStep = 3
    this.showCurrentStep()
  }

  validateEmails(event) {
    const emails = event.target.value
      .split(/[\s,]+/)
      .filter(email => email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))

    this.emailsTarget.dataset.valid = emails.length > 0
  }

  skipInvites(event) {
    event.preventDefault()
    this.emailsTarget.value = ""
  }
}
